import moment from 'moment';

export const valueBalanceReportCols = function (element, translate) {
    const defaultCols =  [ {
        field: "bankName",
        title_key: 'BANK_NAME'
    },{
        field: "bankPlace",
        title_key: 'BANK_PLACE'
    },{
        field: "bic",
        title_key: 'BIC'
    },{
        field: "accountNumber",
        title_key: 'ACCOUNT_NUMBER'
    },{
        field: "currencyCode",
        title_key: 'CURRENCY_CODE'
    },{
        field: "shortName",
        title_key: 'SHORT_NAME'
    },{
        field: "exportName",
        title_key: 'EXPORT_NAME'
    },{
        field: "userNumber",
        title_key: 'USER_NUMBER'
    },{
        field: "closingDate",
        title_key: 'CLOSING_DATE'
    },{
        field: "closingAmount",
        title_key: 'CLOSING_AMOUNT'
    }];

    let result = defaultCols;

    const days = (element.dateRange ? moment(element.dateRange.upperBound).diff(moment(element.dateRange.lowerBound),'days') :
                    Math.abs(element.days) + Math.abs(element.futureDays)) + 1;

    for (let i = 1; i <= days; i++) {
        result = result.concat({
            field: `date${i}`,
            title: `${translate.instant('DATE')} ${i}`
        },{
            field: `valueAmount${i}`,
            title: `${translate.instant('VALUE_AMOUNT_WITHOUT_PRENOT')} ${i}`
        },{
            field: `valueAmountPrenot${i}`,
            title: `${translate.instant('VALUE_PRENOTATION_AMNT')} ${i}`
        })
    }

    return result;
}
